import React from "react";
import StaffRequirementRow from "./StaffRequirementRow";

const StaffRequirementsTable = React.forwardRef(({ requirements, onInputChange, isDisabled, translations }, ref) => {
    const daysOfWeek = [
        translations('days.monday'),
        translations('days.tuesday'),
        translations('days.wednesday'),
        translations('days.thursday'),
        translations('days.friday'),
        translations('days.saturday'),
        translations('days.sunday')
      ];
    return (
        <div ref={ref} className="overflow-x-auto">
            <table className="min-w-[600px] md:w-full border-collapse">
                <thead>
                    <tr>
                        <th className="px-2 py-2 md:px-4 md:py-3 border"></th>
                        {daysOfWeek.map((day, index) => (
                            <th key={index} className="px-2 py-2 md:px-4 md:py-3 border text-xs md:text-sm font-medium text-gray-700">
                                {day.substring(0, 3)}
                                <span className="hidden md:inline">{day.substring(3)}</span>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <StaffRequirementRow
                        label={translations("form.staffRequirement.max")}
                        values={requirements.max}
                        onChange={(index, value) => onInputChange("max", index, value)}
                        isDisabled={isDisabled}
                        isMobile={window.innerWidth < 768}
                    />
                    <StaffRequirementRow
                        label={translations("form.staffRequirement.min")}
                        values={requirements.min}
                        onChange={(index, value) => onInputChange("min", index, value)}
                        isDisabled={isDisabled}
                        isMobile={window.innerWidth < 768}
                    />
                </tbody>
            </table>
        </div>
    );
});

export default StaffRequirementsTable;